export default __webpack_public_path__ + "static/media/sponsors1.fb82d8e9.png";